module.exports = __webpack_public_path__ + "static/uber-logo-070354185d63c5584357293b8d3cd9ca.png";